export function MoneyFilter(value: number, removeCurrencyString = false) {
    if (value < 0) return ' - '

    var formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    })

    var data = formatter.format(value)

    if (removeCurrencyString) data = data.replace('R$', '').trim()

    return data
}
